// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"pT-z","sponsoredTooltipWrapper":"qT-z","sponsoredTooltip":"rT-z","newCard":"sT-z"};